import { h } from '../lib/dom.js';
import { apiGet, apiPost, apiPatch, apiDelete } from '../lib/api.js';
import { openModal, closeModal, toast, confirmModal } from '../lib/ui.js';
import { fmtDate, todayIso } from '../lib/format.js';

const CATEGORY_LABEL = {
  general: 'Genel', subject: 'Ders', topic: 'Konu', question: 'Soru',
  idea: 'Fikir', review: 'Tekrar', important: 'Önemli',
};
export const CATEGORY_KEYS = Object.keys(CATEGORY_LABEL);
export const categoryLabel = (k) => CATEGORY_LABEL[k] || k;

/** Öğrenci notu kartı — koç ve öğrenci panellerinde ortak. */
export function studentNoteCard(note, opts = {}) {
  const { canManage = false, onEdit, refresh = () => {} } = opts;

  const meta = h('div', { class: 'note-meta row row-wrap' },
    h('span', { class: 'note-category c-' + note.category }, categoryLabel(note.category)),
    h('span', {}, fmtDate(note.note_date)),
    note.subject_name ? h('span', {}, '· ' + note.subject_name) : null,
    note.topic_name ? h('span', {}, '· ' + note.topic_name) : null,
    note.tag ? h('span', {}, '· #' + note.tag) : null,
    canManage ? h('span', { class: 'grow' }) : null,
    canManage && typeof onEdit === 'function' ? h('button', {
      class: 'btn btn-ghost btn-sm', onclick: () => onEdit(note),
    }, 'Düzenle') : null,
    canManage ? h('button', {
      class: 'btn btn-danger btn-sm',
      onclick: () => confirmModal({
        title: 'Notu arşivle', message: 'Bu not arşivlenecek.',
        confirmText: 'Arşivle', danger: true,
        onConfirm: async () => {
          await apiDelete('/student-notes/' + note.id);
          toast('Arşivlendi');
          refresh();
        },
      }),
    }, '✕') : null,
  );

  return h('div', { class: 'note-card', style: { borderLeftColor: 'var(--color-primary)' } },
    meta,
    note.title ? h('h4', { style: { marginBottom: 6 } }, note.title) : null,
    h('div', { class: 'note-content' }, note.content),
  );
}

/** Not ekle/düzenle modal'ı — öğrenci kullanımı. */
export function openStudentNoteModal(note, onDone) {
  const isEdit = !!note;
  const title = h('input', { class: 'input', type: 'text', maxlength: 200,
    value: note?.title || '', placeholder: 'Başlık (opsiyonel)' });
  const content = h('textarea', { class: 'textarea', required: true,
    style: { minHeight: '180px' }, placeholder: 'Bugün öğrendiğin, aklına takılan…' },
    note?.content || '');
  const date = h('input', { class: 'input', type: 'date', required: true,
    value: note?.note_date || todayIso() });
  const cat = h('select', { class: 'select' },
    ...CATEGORY_KEYS.map(k => h('option', { value: k }, categoryLabel(k))),
  );
  cat.value = note?.category || 'general';
  const tag = h('input', { class: 'input', type: 'text', maxlength: 50,
    value: note?.tag || '', placeholder: 'örn: sınav' });

  const subjSel = h('select', { class: 'select' }, h('option', { value: '' }, '— Ders (opsiyonel) —'));
  const topicSel = h('select', { class: 'select' }, h('option', { value: '' }, '— Konu (opsiyonel) —'));

  apiGet('/subjects').then(({ subjects }) => {
    subjects.forEach(s => subjSel.appendChild(h('option', { value: s.id }, s.name)));
    subjSel.value = note?.subject_id || '';
    if (subjSel.value) loadTopics(Number(subjSel.value));
  });
  async function loadTopics(subjectId) {
    topicSel.replaceChildren(h('option', { value: '' }, '— Konu (opsiyonel) —'));
    if (!subjectId) return;
    const { topics } = await apiGet('/topics?subject_id=' + subjectId);
    topics.forEach(t => topicSel.appendChild(h('option', { value: t.id }, t.name)));
    topicSel.value = note?.topic_id || '';
  }
  subjSel.addEventListener('change', () => loadTopics(Number(subjSel.value)));

  const save = h('button', { class: 'btn btn-primary',
    onclick: async () => {
      save.disabled = true;
      try {
        const payload = {
          title: title.value || null,
          content: content.value.trim(),
          note_date: date.value,
          category: cat.value,
          subject_id: subjSel.value ? Number(subjSel.value) : null,
          topic_id: topicSel.value ? Number(topicSel.value) : null,
          tag: tag.value || null,
        };
        if (isEdit) await apiPatch('/student-notes/' + note.id, payload);
        else await apiPost('/student-notes', payload);
        toast(isEdit ? 'Not güncellendi' : 'Not eklendi', { type: 'success' });
        closeModal();
        onDone && onDone();
      } catch (err) { toast(err.message, { type: 'error' }); save.disabled = false; }
    },
  }, isEdit ? 'Kaydet' : 'Notu ekle');

  openModal({
    title: isEdit ? 'Notu düzenle' : 'Yeni not',
    size: 'lg',
    body: h('div', { class: 'stack' },
      h('div', { class: 'field' },
        h('label', {}, 'İçerik'),
        content,
      ),
      h('div', { class: 'form-grid' },
        h('div', { class: 'field' }, h('label', {}, 'Kategori'), cat),
        h('div', { class: 'field' }, h('label', {}, 'Tarih'), date),
        h('div', { class: 'field' }, h('label', {}, 'Etiket'), tag),
      ),
      h('div', { class: 'field' }, h('label', {}, 'Başlık'), title),
      h('div', { class: 'form-grid' },
        h('div', { class: 'field' }, h('label', {}, 'Ders'), subjSel),
        h('div', { class: 'field' }, h('label', {}, 'Konu'), topicSel),
      ),
    ),
    actions: [
      h('button', { class: 'btn btn-ghost', onclick: closeModal }, 'Vazgeç'),
      save,
    ],
  });
}
